module.exports = require("fbemitter");


//////////////////
// WEBPACK FOOTER
// external "fbemitter"
// module id = 22
// module chunks = 0